import { LocationVarKey } from "@swivl-mono/types";

import { IS_EQUAL, IS_NOT_EQUAL, IS_TRUE } from "../../../Components/Worksheets/Types/Worksheet.Interface";
import {
  DropdownRow,
  Indent,
  InputRow,
  MultiLineRow,
  PageHeader,
  SectionHeader,
  SwitchRow,
  TextAreaRow,
  TextRow
} from "../../../Components/Worksheets/WorksheetComponent/WorksheetComponents";
import { usePropertiesGetLocationIds } from "../../../Hooks/usePropertiesGetLocationIds";

export const PAGE_KEYS: LocationVarKey[] = [
  LocationVarKey.VehicleStorageGuidelines1,
  LocationVarKey.VehicleStorageGuidelines2,
  LocationVarKey.VehicleStorageGuidelines3,
  LocationVarKey.VehicleStorageGuidelines4
];

export default function WorksheetView() {
  const page = usePropertiesGetLocationIds();
  return (
    <>
      <PageHeader {...page} subheading="">
        {" "}
        Vehicle Storage Guidelines
      </PageHeader>

      <TextAreaRow {...page} marginTop label=" Message 1" keyName={LocationVarKey.VehicleStorageGuidelines1} />
      <TextAreaRow {...page} marginTop label=" Message 2" keyName={LocationVarKey.VehicleStorageGuidelines2} />
      <TextAreaRow
        {...page}
        marginTop
        label=" Message 3 (Optional)"
        keyName={LocationVarKey.VehicleStorageGuidelines3}
        enableSwitchVar={LocationVarKey.VehicleStorageGuidelines3Enabled}
      />
      <TextAreaRow
        {...page}
        marginTop
        label=" Message 4 (Optional)"
        keyName={LocationVarKey.VehicleStorageGuidelines4}
        enableSwitchVar={LocationVarKey.VehicleStorageGuidelines4Enabled}
      />
    </>
  );
}
